// Library Imports
import React, { useState } from 'react';
import { FiChevronRight, FiChevronDown } from 'react-icons/fi';
import { Link } from 'gatsby';
import { ListGroup } from 'react-bootstrap';

// Style imports
import SideBarNavStyles from './SideBarNav.module.scss';

type TocData = {
  name: string;
  link: string;
  children?: TocData[];
  isActive?: boolean;
};

/**
 * Toc: Generate the site Toc SideBar content.
 * @param param0
 * @returns
 */
function SideBarNav(props: { siteTocArray: TocData[] }) {
  const siteTocArray = props.siteTocArray;
  // Sentinel Statement to stop recursive loop through siteTocArray.
  if (!Array.isArray(siteTocArray)) {
    return null;
  }

  return (
    <>
      <ListGroup as="ol" className={SideBarNavStyles.ol}>
        {siteTocArray.map((item: TocData) => {
          const [isOpen, setOpen] = useState(item.isActive);
          const toggleOpen = () => setOpen((b) => !b);

          return (
            <ListGroup.Item
              as="li"
              className={
                SideBarNavStyles.li +
                (item.children ? '' : ` ${SideBarNavStyles.noChildren}`)
              }
              key={item.name}
              active={item.isActive}
            >
              {item.children ? (
                <div
                  className={
                    SideBarNavStyles.section +
                    (item.isActive ? ` ${SideBarNavStyles.isActive}` : '')
                  }
                >
                  <button
                    type="button"
                    className={SideBarNavStyles.button}
                    onClick={toggleOpen}
                  >
                    {isOpen ? <FiChevronDown /> : <FiChevronRight />}
                  </button>
                  <Link
                    className={
                      SideBarNavStyles.link +
                      (item.isActive ? ` ${SideBarNavStyles.isActive}` : '')
                    }
                    to={`${item.link}/`}
                  >
                    {item.name}
                  </Link>
                </div>
              ) : (
                <div
                  className={
                    SideBarNavStyles.topic +
                    (item.isActive ? ` ${SideBarNavStyles.isActive}` : '')
                  }
                >
                  <Link
                    className={
                      SideBarNavStyles.link +
                      (item.isActive ? ` ${SideBarNavStyles.isActive}` : '')
                    }
                    to={`${item.link}/`}
                  >
                    {item.name}
                  </Link>
                </div>
              )}
              {isOpen && <SideBarNav siteTocArray={item.children} />}
            </ListGroup.Item>
          );
        })}
      </ListGroup>
    </>
  );
}

export default SideBarNav;
